/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/div.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Divide one value by another. For numeric operands, if either field is multivalued\nthen the result is `null`.',
  note: 'Division of two integer types will yield an integer result, rounding towards 0. "\nIf you need floating point division, `Cast (::)` one of the arguments to a `DOUBLE`.\nFor dense_vector operations, both arguments should be dense_vectors. Inequal vector dimensions generate null result.\n',
  params: {
    lhs: 'A numeric value.',
    rhs: 'A numeric value.',
  },
};

export default docs;
